export { default } from "./Advantages";
